module.exports = function(bootstrap) {
    bootstrap.run(["Service", function (Service) {
        return new Service({
            name: 'reportCodesValidate',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/validations/v1/report-codes",
            validate: function(data) {
                return this.post({
                	payload: data
                });
            }
        });
    }]);
};
